export default __webpack_public_path__ + "locales/el-GR/Errors.json?hash=13cf97ec165bf6065141e97ee9462b5f";